import React, { useState , useEffect } from "react";
import axios from "axios";

import { useUser } from "../../state/reactquery";
import { axios_gestion_getallfomulesempty } from "../../axios/axios_gestion";

import './EcranDev2.scss' ;

function EcranDev2(){
    const [isRecording, setIsRecording] = useState(false);
    const [mediaRecorder, setMediaRecorder] = useState(null);
    const [audioBlob, setAudioBlob] = useState(null);
    const [audioStream, setAudioStream] = useState(null);
    const {data: user} = useUser(localStorage.getItem('token'))  ;

    const essai = async ()=>{

     await axios.post("dev/essai", {}, {headers: { "Content-Type": "application/json" }});
  }


  useEffect(async()=>{    let reqformules = await axios_gestion_getallfomulesempty() ;
   console.log('REQ', reqformules)
  },[])


  useEffect(()=>{
    const autocompleteElement = document.getElementById("autocomplete");
    autocompleteElement.addEventListener("gmpx-placechange", () => {
    const place = autocompleteElement.getPlace();
    console.log("Lieu sélectionné :", place);
  });
  }) ;
    const envoifichier = async ()=>{

        mediaRecorder?.stop();
        setIsRecording(false);
        const formData = new FormData();
        formData.append("audio", audioBlob, "recording.webm");
       await axios.post("dev/essai", formData, {headers: { "Content-Type": "multipart/form-data" }});
    }

    const enregistrer = async()=>{
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const recorder = new MediaRecorder(stream);
        const chunks = [];

        recorder.ondataavailable = (event) => {chunks.push(event.data); };

        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: "audio/webm" });
          setAudioBlob(blob);
          stream.getTracks().forEach((track) => track.stop());
          setAudioStream(null);
        };

        recorder.start();
        setMediaRecorder(recorder);
        setAudioStream(stream);
        setIsRecording(true);
    }
  
    const handleButtonClick = async () => {
      if (!isRecording) {await enregistrer() ;   
      } else {await  envoifichier()}
    };

    const findmails =async ()=>{
      const toto =  await axios({method:'POST',url :`/googleapis/myemails`,data:{"email" :user.email}  ,headers:{'Accept':'application/json'} });
       const emails = toto.data ;
       let maliste =[] ;
       emails.forEach(mail=>mail.snippet?.includes('RGPD DROIT DES PERSONNES') && maliste.push(mail.content?.match(/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g)[0]))

       console.log(maliste)
    }
  
        return(<div className="ecrandevff">
                  <h1>DEV2</h1>
                  <div>
                    <button onClick={handleButtonClick}>
                    {isRecording ? "Arrêter et envoyer" : "Démarrer l'enregistrement"}
                    </button>
                    <button onClick={essai}>V</button>
                  </div>
                  <h2>Mails CTO</h2>
                  <button onClick={findmails}>Click</button>

                  <br/>

                  <h2>Nouveau google maps</h2>

                  <gmpx-place-autocomplete
                      id="autocomplete"
                      // style="width: 100%;"
                      componentRestrictions='{"country": ["fr"]}'
                      placeholder="Recherchez une adresse">
                      
                  </gmpx-place-autocomplete>
            
                </div>)
}

export default EcranDev2 ;

